import { useEffect, useRef, useState } from "react";

export function useProjectImagePolling(fetchFn: () => Promise<void>, totalFileCount: number, currentCount: number) {
  const [isPolling, setIsPolling] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const fetchRef = useRef(fetchFn);

  // 매 렌더마다 최신 fetchFn을 ref에 반영
  useEffect(() => {
    fetchRef.current = fetchFn;
  }, [fetchFn]);

  const stop = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = null;
    setIsPolling(false);
  };

  const start = () => {
    if (intervalRef.current) return;
    setIsPolling(true);
    intervalRef.current = setInterval(() => fetchRef.current(), 2000); // ← ref로 최신 함수 호출
  };

  useEffect(() => {
    if (isPolling && totalFileCount > 0 && currentCount >= totalFileCount) {
      stop();
    }
  }, [currentCount, totalFileCount, isPolling]);

  useEffect(() => () => stop(), []);

  return { isPolling, start, stop };
}
